import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem,
} from '@ng-bootstrap/ng-bootstrap';
import { PartialAccordionTitleComponent } from '@legacy/common-ui-partials';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { GenericRichTextDirective, ScIconPipe } from '@core/jss-utils';

@Component({
  selector: 'wl-taxonomy-accordion',
  templateUrl: './taxonomy-accordion.component.html',
  styleUrls: [
    './taxonomy-accordion.component.ed.scss',
    './taxonomy-accordion.component.essent.scss',
  ],
  standalone: true,
  imports: [
    NgbAccordionDirective,
    NgbAccordionItem,
    NgbAccordionHeader,
    NgbAccordionButton,
    PartialAccordionTitleComponent,
    NgbAccordionCollapse,
    NgbAccordionBody,
    FaIconComponent,
    GenericRichTextDirective,
    ScIconPipe,
  ],
})
export class TaxonomyAccordionComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  @Output()
  navigateToLink = new EventEmitter<string>();
}
